import { useEffect, useCallback } from "react";

const useHorizontalScrollButtons = ({
                                        scrollRef,
                                        leftBtnRef,
                                        rightBtnRef,
                                        dependency = [],
                                    }) => {
    const checkScroll = useCallback(() => {
        const el = scrollRef.current;

        if (!el) return;

        const canLeft = el.scrollLeft > 0;

        const canRight =
            el.scrollLeft < el.scrollWidth - el.clientWidth - 1;

        if (leftBtnRef.current) {
            leftBtnRef.current.style.opacity =
                canLeft ? "1" : "0";

            leftBtnRef.current.style.pointerEvents =
                canLeft ? "auto" : "none";
        }

        if (rightBtnRef.current) {
            rightBtnRef.current.style.opacity =
                canRight ? "1" : "0";

            rightBtnRef.current.style.pointerEvents =
                canRight ? "auto" : "none";
        }
    }, [scrollRef, leftBtnRef, rightBtnRef]);

    useEffect(() => {
        const el = scrollRef.current;

        if (!el) return;

        checkScroll();

        el.addEventListener("scroll", checkScroll, {
            passive: true,
        });

        window.addEventListener("resize", checkScroll);

        return () => {
            el.removeEventListener("scroll", checkScroll);

            window.removeEventListener("resize", checkScroll);
        };
    }, [checkScroll, ...dependency]);

    const scroll = useCallback(
        (direction, amount = 300) => {
            scrollRef.current?.scrollBy({
                left: direction === "left" ? -amount : amount,
                behavior: "smooth",
            });
        },
        [scrollRef]
    );

    return {
        scroll,
        checkScroll,
    };
};

export default useHorizontalScrollButtons;